import type { ReactNode } from 'react'
import React, { type FunctionComponent, useContext as useContextCore } from 'react'

type StatusComponentProps = { status: string } & Record<any, any>
export type StatusDropdownBreadcrumbComponent = {
  status: FunctionComponent<StatusComponentProps>
  statusBadge: FunctionComponent<StatusComponentProps>
  menuItem?: ReactNode
}

export type StatusBreadcrumbProviderProps = {
  loading: boolean
  component: StatusDropdownBreadcrumbComponent
  status: string
  statusMenu: {
    value: string
  }[]
  onUpdate: (status: string) => Promise<void>
  disabled: boolean
  children: React.ReactNode
}

export type StatusBreadcrumbContext = Omit<StatusBreadcrumbProviderProps, 'children'>

const context = React.createContext<StatusBreadcrumbContext>({} as StatusBreadcrumbContext)
const CoreProvider = context.Provider

export const StatusBreadcrumbProvider = ({ children, ...props }: StatusBreadcrumbProviderProps) => {
  return <CoreProvider value={{ ...props }}>{children}</CoreProvider>
}

export const useStatusBreadcrumbContext = () => useContextCore(context)
